import { useTheme } from '@emotion/react';
import NextLink from 'next/link';
import PropTypes from 'prop-types';

import Avatar from 'shopper/components/Avatar';
import Block from 'shopper/components/Block';
import Flex from 'shopper/components/Flex';
import Text from 'shopper/components/Text';

import { toStoreCouponsLink } from 'lib/links';

const StoresDropdownItem = ({
  hasBorder,
  showStoreImage,
  pageFrom,
  pageImage,
  pageParam,
  pageTitle,
  onClick,
}) => {
  const theme = useTheme();

  return (
    <NextLink href={toStoreCouponsLink(pageParam)} passHref>
      <Block
        width="9rem"
        as="a"
        mb={2}
        mx={5}
        pb={2}
        borderBottom={hasBorder ? '1px solid' : null}
        borderColor={hasBorder ? theme.app.storesDropdown.cardBorder : null}
        onClick={onClick}
      >
        <Flex alignItems="center">
          {showStoreImage && (
            <Avatar
              size="size5"
              src={pageImage}
              alt={pageTitle}
              description={pageTitle}
            />
          )}
          <Text whiteSpace="nowrap" ml={2} bold>
            {pageTitle}
          </Text>
        </Flex>
        <Text size="size2" mt={1} color={theme.app.storesDropdown.foreground}>
          {pageFrom}
        </Text>
      </Block>
    </NextLink>
  );
};

StoresDropdownItem.defaultProps = {
  hasBorder: false,
  showStoreImage: false,
};

StoresDropdownItem.propTypes = {
  hasBorder: PropTypes.bool,
  showStoreImage: PropTypes.bool,
  pageFrom: PropTypes.string.isRequired,
  pageImage: PropTypes.string.isRequired,
  pageParam: PropTypes.string.isRequired,
  pageTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default StoresDropdownItem;
